import React, { useState, useEffect, useCallback } from 'react'
import { FormGroup, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { Popover } from 'antd'
import apiBarcode from '../../../services/api/apiBarcode'
import { pushNewItemHistory } from '../../../services/api/apiItemHistory'
import { detectCarrierShippingRule } from '../../../services/api/apiPacking'
import { bulkUpdateTags } from '../../../services/api/apiNextBarcode'
import { getGroupedByStatus, getTooltipContent, BarcodeListModal } from '../shared/BulkActionTooltipModalUtils'


function BulkUpdateAddress(props) {
    const { selectedItems = [], items = [], resetBulkAll, reloadItems, closeMenu } = { ...props }
    const [isOpen, setIsOpen] = useState(false)
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemsError, setItemsError] = useState([])
    const [errorShippingCarrier, setErrorShippingCarrier] = useState([])
    const [listSelectedItem, setListSelectedItem] = useState([])
    // const [orderNumber, setOrderNumber] = useState('')
    const [name, setName] = useState('')
    const [address1, setAddress1] = useState('')
    const [address2, setAddress2] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [country, setCountry] = useState('')
    const [phone, setPhone] = useState('')
    const [postalCode, setPostalCode] = useState('')
    // const [qship, setQship] = useState('')
    // const [ioss, setIoss] = useState('')
    const [isChecked, setIsChecked] = useState(false)
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [isShipOffice, setIsShipOffice] = useState(false)
    // Store original values to restore when unchecking
    const [originalValues, setOriginalValues] = useState({})

    const OFFICE_ADDRESS = {
        address1: 'HD Mon City',
        city: 'Hà Nội',
        country: 'VN',
    }

    useEffect(() => {
        const isMatch = address1 === OFFICE_ADDRESS.address1 &&
            city === OFFICE_ADDRESS.city &&
            country === OFFICE_ADDRESS.country;
        if (isMatch !== isShipOffice) {
            setIsShipOffice(isMatch);
        }
    }, [address1, city, country]);

    const handleShowModal = () => {
        setIsOpen(true)
    }

    const handleCloseModal = () => {
        setIsOpen(false)
        setItemsSuccess([])
        setItemsError([])
        setErrorShippingCarrier([])
        // setOrderNumber('')
        setName('')
        setAddress1('')
        setAddress2('')
        setCity('')
        setState('')
        setCountry('')
        setPhone('')
        setPostalCode('')
        // setQship('')
        // setIoss('')
        setIsChecked(false)
        setIsShipOffice(false)
        setLoadingBtn(false)
        closeMenu()
        resetBulkAll()
        reloadItems()
    }

    const _diff = (oldObj, newObj) => {
        return Object.entries(newObj).map(([key, value]) => {
            if (oldObj[key] !== newObj[key]) {
                return key
            }
            return null
        }).filter(Boolean)
    }

    const onSave = async () => {
        setLoadingBtn(true)
        try {
            const payload = {
                // orderNumber: orderNumber,
                name: name.trim(),
                address1: address1.trim(),
                address2: address2.trim(),
                city: city.trim(),
                state: state.trim(),
                country: country.trim(),
                phone: phone.trim(),
                postalCode: postalCode.trim(),
                // qship: qship,
                // ioss: ioss,
            }
            let listSuccess = []
            let listError = []
            let listErrorSC = []
            await Promise.all(listSelectedItem.map(async i => {
                const newItem = { ...i, ...payload }

                const diff = _diff(i, newItem)
                let from = []
                let to = []


                diff.forEach(itemDiff => {
                    from.push(`${itemDiff}: ${i[itemDiff]}`)
                    to.push(`${itemDiff}: ${newItem[itemDiff]}`)
                })
                try {
                    const resUpdated = await apiBarcode.updateBarcode(i._id, payload)
                    const { success, message } = resUpdated.data
                    if (success) {
                        listSuccess.push(i._id)
                        pushNewItemHistory(`${i.barcodeNumber}_1`, {
                            event_key: 'edit_shipping_address',
                            event_description: 'Edit shipping address by bulk action.',
                            event_meta: {
                                from: from.toString(', '),
                                to: to.toString(', ')
                            }
                        })
                    } else { listError.push({ _id: i._id, message: message }) }

                    // Handle tag updates for ship_VP
                    const currentTags = i.tags || []
                    const hasShipVP = currentTags.includes('ship_VP')
                    const hasShippedVhmc = currentTags.includes('shipped_vhmc')

                    if (hasShippedVhmc) {
                        listError.push({ _id: i._id, message: 'Không thể thay đổi tag khi đã shipped vhmc' })
                    } else if (isShipOffice !== hasShipVP) {
                        try {
                            const tagPayload = {
                                barcode_numbers: [i.barcodeNumber],
                                tags: isShipOffice ? ["ship_VP"] : ["ship_VP", "shipped_vhmc", "returned"],
                                action: isShipOffice ? 'push' : 'pull',
                            }
                            await bulkUpdateTags(tagPayload)
                        } catch (tagError) {
                            listError.push({ _id: i._id, message: `Tag update error: ${tagError.message}` })
                        }
                    }

                    if (isChecked) {
                        try {
                            const { success: ssc, message: msc } = await detectCarrierShippingRule({ barcodeNumber: i.barcodeNumber })
                            if (!ssc) {
                                listErrorSC.push({ _id: i._id, message: msc })
                                console.log(msc)
                            }
                        } catch (error) {
                            listErrorSC.push({ _id: i._id, message: error.message })
                            console.log(error)
                        }
                    }
                } catch (error) {
                    listError.push({ _id: i._id, message: error.message })
                    console.log(error)
                }

            }))
            setItemsSuccess(listSuccess)
            setItemsError(listError)
            setErrorShippingCarrier(listErrorSC)
            setLoadingBtn(false)

        } catch (error) {
            console.log(error)
        } finally {
            setLoadingBtn(false)
        }
    }

    const handleChangeInput = (e) => {
        const { name, value } = e.target
        // if (name === 'orderNumber') setOrderNumber(value)
        if (name === 'name') setName(value)
        if (name === 'address1') setAddress1(value)
        if (name === 'address2') setAddress2(value)
        if (name === 'city') setCity(value)
        if (name === 'state') setState(value.toUpperCase())
        if (name === 'country') setCountry(value)
        if (name === 'phone') setPhone(value)
        if (name === 'postalCode') setPostalCode(value)
        // if (name === 'qship') setQship(value)
        // if (name === 'ioss') setIoss(value)
    }

    const handleCheck = () => {
        setIsChecked(!isChecked)
    }
    const renderIconLoading = () => {
        if (loadingBtn)
            return <i className='icon-spinner2 spinner ml-2' />
    }
    const getListItems = () => {
        const list = items.filter(i => selectedItems.includes(i._id))
        setListSelectedItem(list)
        // Check if all items have ship_VP tag
        const allHaveShipVP = list.every(item => item.tags && item.tags.includes('ship_VP'))
        const noneHaveShipVP = list.every(item => !item.tags || !item.tags.includes('ship_VP'))
        setIsShipOffice(allHaveShipVP)

        // Store original values for potential restoration
        if (list.length > 0) {
            const originals = {}
            list.forEach(item => {
                originals[item._id] = {
                    name: item.name,
                    address1: item.address1,
                    address2: item.address2,
                    city: item.city,
                    state: item.state,
                    country: item.country,
                    postalCode: item.postalCode
                }
            })
            setOriginalValues(originals)
        }

        // setOrderNumber(list[0].orderNumber)
        setName(list[0].name)
        setAddress1(list[0].address1)
        setAddress2(list[0].address2)
        setCity(list[0].city)
        setState(list[0].state)
        setCountry(list[0].country)
        setPhone(list[0].phone)
        setPostalCode(list[0].postalCode)
        // setQship(list[0].qship)
        // setIoss(list[0].ioss)
    }

    const showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Change shipping address success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    const onChangeCheckbox = (e) => {
        const checked = e.target.checked
        setIsShipOffice(checked)
        if (checked) {
            // Autofill office address
            setName('VP Merchize')
            setAddress1('HD Mon City')
            setAddress2('')
            setCity('Hà Nội')
            setState('')
            setCountry('VN')
            setPostalCode('')
        } else {
            // Restore original values
            if (Object.keys(originalValues).length > 0 && listSelectedItem.length > 0) {
                // For bulk operations, restore to first item's values or common approach
                // Restore to first selected item's original values
                const firstItemId = listSelectedItem[0]._id
                if (originalValues[firstItemId]) {
                    const orig = originalValues[firstItemId]
                    setName(orig.name)
                    setAddress1(orig.address1)
                    setAddress2(orig.address2)
                    setCity(orig.city)
                    setState(orig.state)
                    setCountry(orig.country)
                    setPostalCode(orig.postalCode)
                }
            }
        }
    }
    useEffect(() => {
        getListItems()
    }, [selectedItems])

    const listItemsDisable = listSelectedItem.filter(itemH => {
        const itemTags = itemH.tags || []
        const hasShipVP = itemTags.includes('ship_VP')
        const hasShippedVhmc = itemTags.includes('shipped_vhmc')
        const hasReturned = itemTags.includes('returned')
        const isStatusDisable = ['labelled', 'packaged', 'cancelled', 'cancel-ship'].includes(itemH.production_status)
        const isReturnDisable = hasShipVP && hasShippedVhmc && !hasReturned

        return isStatusDisable || isReturnDisable
    })
    const listItemsHasLabel = listSelectedItem.filter(itemH => itemH.meta && itemH.meta.label)
    const disabledBtn = listItemsDisable.length > 0 || listItemsHasLabel.length > 0
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState(null)

    const openModalFn = useCallback((type) => {
        setModalType(type)
        setShowModal(true)
    }, [])

    return (
        <div className='BulkUpdateAddress'>
            <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', width: '100%' }}>
                <Button color="link" onClick={handleShowModal} disabled={disabledBtn}>Update address</Button>
                {disabledBtn && (
                    <Popover content={getTooltipContent(listItemsHasLabel, listItemsDisable, openModalFn)} title="Lý do không thể update address" trigger="hover">
                        <i className='icon-info3 cursor-pointer text-info' style={{ position: 'absolute', right: '10px', top:'calc(50% - 8px)' }} />
                    </Popover>
                )}
            </div>
            {isOpen && (
                <Modal isOpen={isOpen} toggle={handleCloseModal} >
                    <ModalHeader toggle={handleCloseModal}>Sửa địa chỉ</ModalHeader>
                    <ModalBody style={{ maxHeight: '75vh', overflowY: 'scroll' }}>
                        <div className="shippingAddress ListGenLabels">
                            <h3>Shipping address</h3>
                            {(!itemsSuccess.length && !itemsError.length) ?
                                <>
                                    <div className="mb-3">
                                        <FormGroup check>
                                            <Label check>
                                                <div className='d-flex align-items-center'>
                                                    <Input
                                                        type="checkbox"
                                                        checked={isShipOffice}
                                                        onChange={onChangeCheckbox}
                                                        className='d-block'
                                                        style={{ position: 'relative', marginTop: 0, marginRight: 10 }}
                                                    />
                                                    Ship văn phòng
                                                </div>
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    {/* <FormGroup>
                                        <Label>Order Number</Label>
                                        <Input name='orderNumber' value={orderNumber || ''} onChange={handleChangeInput} />
                                    </FormGroup> */}
                                    <FormGroup>
                                        <Label>Name</Label>
                                        <Input name='name' value={name || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Address1</Label>
                                        <Input name='address1' value={address1 || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Address2</Label>
                                        <Input name='address2' value={address2 || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>City</Label>
                                        <Input name='city' value={city || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>State</Label>
                                        <Input name='state' value={state || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Country</Label>
                                        <Input name='country' value={country || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Phone</Label>
                                        <Input name='phone' value={phone || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Postal Code</Label>
                                        <Input name='postalCode' value={postalCode || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    {/* <FormGroup>
                                        <Label check>FastShip</Label>
                                        <Input name='qship' value={qship || ''} onChange={handleChangeInput} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>IOSS number</Label>
                                        <Input name='ioss' value={ioss || ''} onChange={handleChangeInput} />
                                    </FormGroup> */}
                                </> : <>
                                    {
                                        listSelectedItem.length > 0 && (
                                            listSelectedItem.map(item => {
                                                return (
                                                    <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                                        <div className="IconStatus mr-2">
                                                            {itemsSuccess.includes(item._id) && (
                                                                <i className="icon-check text-success" />
                                                            )}
                                                            {
                                                                (itemsError.find(itemErr => item._id === itemErr._id) !== undefined && itemsError.find(itemErr => item._id === itemErr._id).message) && (
                                                                    <i className="icon-cross text-danger" />
                                                                )
                                                            }
                                                        </div>
                                                        <div className="ContentGenLabel">
                                                            <strong>#{item.barcodeNumber}</strong> - orderNumber: {item.orderNumber}
                                                            {showMessage(itemsError, itemsSuccess, item._id)}
                                                            {!!errorShippingCarrier.length && !!errorShippingCarrier.find(itemErr => item._id === itemErr._id).message &&
                                                                <span className="d-sm-block text-danger">
                                                                    {`Change Shipping Carrier:
                                                                    ${errorShippingCarrier.find(itemErr => item._id === itemErr._id).message}`
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    }
                                </>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {(!itemsSuccess.length && !itemsError.length) ?
                            <>
                                <Label check className="d-flex align-items-center mr-2">
                                    <Input
                                        type="checkbox" value={isChecked} onChange={handleCheck}
                                        style={{ position: 'unset', marginTop: 'unset', marginLeft: 'unset', cursor: 'pointer' }}
                                        className='CheckboxShippingCarrier mx-2'
                                    />
                                    Change Shipping Carrier?
                                </Label>
                                <Button color="secondary" onClick={handleCloseModal}>Cancel</Button>{' '}
                                <Button color="primary" onClick={onSave}>
                                    Save
                                    {renderIconLoading()}
                                </Button>
                            </> : <>
                                <Button disabled={false} onClick={handleCloseModal} className="bg-grey ml-2">
                                    Close
                                </Button>
                            </>}
                    </ModalFooter>
                </Modal>
            )}
            {showModal && (
                <BarcodeListModal
                    modalType={modalType}
                    showModal={showModal}
                    listItemsHasLabel={listItemsHasLabel}
                    listItemsDisable={listItemsDisable}
                    closeModalFn={() => setShowModal(false)}
                />
            )}
        </div>
    )
}

export default BulkUpdateAddress
